import { useNavigate } from "react-router-dom"
import { MERCHANT_ADMIN_PRODUCTS_CREATE_ROUTE, MERCHANT_ADMIN_ROUTE } from "../../../../../constants/routes"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardTabs } from "../../../../../shared/components/tabs/StandardTabs"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { Button } from "../../../../office/admin/components/Button"
import { SortProductsTab } from "./SortProductsTab"
import { AllProductsTab } from "./AllProductsTab"
import { EnvironmentBasedComponent } from "../../../../../shared/components/placeholders/EnvironmentBasedComponent"

export function Products() {
    const { l10n } = useAppLocalization()
    const navigate = useNavigate()

    const tabs = [
        { label: l10n.getString("products-tab-all-products"), component: <AllProductsTab /> },
        {
            label: l10n.getString("products-tab-sort-products"),
            component: <EnvironmentBasedComponent Component={SortProductsTab} />,
        },
    ]

    return (
        <>
            <LocalizedStrict id="products-page-header" attrs={{ title: true }}>
                <PageHeader
                    title="Products"
                    page={Page.MERCHANT_PRODUCTS}
                    rightElement={
                        <LocalizedStrict id="products-create-product-button">
                            <Button
                                onClick={() => {
                                    navigate(MERCHANT_ADMIN_PRODUCTS_CREATE_ROUTE)
                                }}
                            >
                                Create product
                            </Button>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-products-header">
                            <Breadcrumb>Products</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-products">
                            <Breadcrumb>Products</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <StandardTabs tabs={tabs} />
        </>
    )
}
